import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { isLoaded } from 'react-redux-firebase';
import { AppView, ListSection, ListDetail, CardVirtual } from 'medua-components';

import { history } from '../../store';

/* eslint-disable */
@translate('schools')
export default class School extends Component {

  constructor(props) {
    super(props)
    this.state = {}

    this.openBilling = this.openBilling.bind(this)
    this.openSettings = this.openSettings.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openBilling() {
    history.push('/account/billing');
  }
  openSettings() {
    history.push('/account/school');
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    let { school } = this.props.user
    return (
      <AppView
        loading={ !isLoaded(school) }
        headerSize="large"
        background="default-school"
        title={ school && school.name ? school.name : this.props.t('schools:title') }
        className="account"
      >
        <ListSection margin>
          <ListDetail
            meta={ this.props.t('schools:type.title') }
            text={ school && school.type ? this.props.t(`schools:type.${school.type}`) : 'Fehler' } />
        </ListSection>
        <ListSection
          title={ this.props.t('schools:location.title') }>
          <ListDetail
            meta={ this.props.t('schools:location.street') }
            text={ school && school.location && school.location.street ? school.location.street : 'Unbekannt' } />
          <ListDetail
            meta={ this.props.t('schools:location.zip') }
            text={ school && school.location && school.location.zip ? school.location.zip : 'Unbekannt' } />
          <ListDetail
            meta={ this.props.t('schools:location.city') }
            text={ school && school.location && school.location.city ? school.location.city : 'Unbekannt' } />
          <ListDetail
            meta={ this.props.t('schools:location.country') }
            text={ school && school.location && school.location.country ? school.location.country : 'Unbekannt' } />
        </ListSection>
        <ListSection
          title={ this.props.t('schools:contact.title') }>
          <ListDetail
            meta={ this.props.t('schools:contact.phone') }
            text={ school && school.contact && school.contact.phone ? school.contact.phone : 'Unbekannt' } />
          <ListDetail
            meta={ this.props.t('schools:contact.mail') }
            text={ school && school.contact && school.contact.mail ? school.contact.mail : 'Unbekannt' } />
          <ListDetail
            meta={ this.props.t('schools:contact.web') }
            text={ school && school.contact && school.contact.web ? school.contact.web : '' } />
        </ListSection>
        <ListSection
          title={ this.props.t('schools:membership.title') }>
          <CardVirtual big
            logo
            title="Basic"
            name={ school && school.name ? school.name : '' }
            since={{
              text: this.props.t('schools:membership.info'),
              date: this.props.user.meta && this.props.user.meta.createdAt
            }} />
        </ListSection>
      </AppView>
    );
  }
}



// <main className="split">
//   <aside className="school-full">
//     <PanelList
//       title="School"
//       color="school panel-list-view-full"
//       actionRight={this.openSettings}
//       actionRightIcon="icon-settings"
//     >
//       <div className="panel-list-header" style={{ backgroundImage: 'url(../assets/img/ey_logo.png)', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'none' }} />
//       <div className="panel-list-content">
//         <div className="panel-list-content-title">
//           <h2>{ this.props.school ? this.props.school.name : '' }</h2>
//           <div className="panel-list-content-subtitle">{ this.props.school ? this.props.school.category : '' }</div>
//         </div>
//         <div className="panel-list-content-info">
//           <i className="icon icon-location" />
//           { this.props.school ? this.props.school.location : '' }
//         </div>
//         <div className="panel-list-content-info">
//           <i className="icon icon-contact" />
//           { this.props.school ? this.props.school.contact_name : '' }
//           <div className="panel-list-content-info-row">{ this.props.school ? this.props.school.contact_position : '' }</div>
//         </div>
//         <div className="panel-list-content-info">
//           <i className="icon icon-mail" />
//           { this.props.school ? this.props.school.contact_phone : '' }
//         </div>
//         <div className="panel-list-content-info">
//           <i className="icon icon-mail" />
//           { this.props.school ? this.props.school.contact_email : '' }
//         </div>
//         <div className="panel-list-content-title">
//           <h3>Subscription</h3>
//           <div className="panel-list-content-title-action">
//           </div>
//         </div>
//         <div className="membership-card pro business">
//           <div className="membership-card-title">School Pro</div>
//           <div className="membership-card-since">Since 2018</div>
//           <div className="membership-card-logo">
//             <i className="icon icon-logo" />
//           </div>
//           <div className="membership-card-button">
//             <button className="button" onClick={ this.openBilling }>Manage</button>
//           </div>
//         </div>
//       </div>
//     </PanelList>
//   </aside>
//   <SchoolTabContent school={this.props.school} />
// </main>



// WEBPACK FOOTER //
// ./src/routes/school/index.jsx